import React, { useEffect, useMemo, useState } from 'react';

import { groupBy } from '../../utils/collection';
import getPeriodTableConfig from '../../utils/period/periodTable';
import { getConfig } from '../../utils/table';
import { convertDataWithOthers, getOthersTableConfig } from '../../utils/othersTable';
import EnhancedTable from './EnhancedTable';
import EventTableTabs from './EventTableTabs';

const EventTableView = ({ className, zoneId, result, metainf, executeTime, showTabs = false }) => {
  const [selectedIndex, setIndex] = useState(0);
  // группируем ивенты по uniqueChar, чтобы события с дополнительными периодами попали в свою группу.
  const events = result.map((r, index) => ({ ...r, groupBy: r.info.uniqueChar[0] || `${index}` }));
  const groupedEvents = (Object.entries(groupBy(events, (e) => e.groupBy)) || []).map(
    ([, event]) => event
  );

  // при получении нового результата, по дефолту включается первая таблица.
  useEffect(() => {
    setIndex(0);
  }, [executeTime]);

  const selectedEvents = groupedEvents[selectedIndex] || [{ result: { rows: [] } }];

  // если в группе несколько событий значит она имеет дополнительные периоды.

  const isOthers =
    selectedEvents.length > 1 &&
    selectedEvents.some(
      ({ info }) => info.uniqueChar.length > 1 && info.uniqueChar.includes('Others')
    );

  const config = () => {
    if (selectedEvents.length > 1) {
      if (isOthers) {
        const isSplit = selectedEvents.some(
          (event) => event.result?.columns?.length > 2 && event.info?.splitBy
        );
        return isSplit
          ? getConfig(convertDataWithOthers(selectedEvents), metainf, zoneId, true)
          : getOthersTableConfig(selectedEvents, metainf, zoneId);
      }
      return getPeriodTableConfig(selectedEvents, metainf, zoneId);
    }
    return getConfig(selectedEvents[0], metainf, zoneId, true);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const { rows, columns, pivotBy } = useMemo(config, [executeTime, selectedIndex]);

  return (
    <>
      {showTabs && !!result.length && (
        <EventTableTabs
          groupedEvents={groupedEvents}
          selectedIndex={selectedIndex}
          onSelect={(index) => setIndex(index)}
        />
      )}
      <div className={className}>
        <EnhancedTable
          className="enhanced-table"
          columns={columns}
          data={rows}
          pivotBy={pivotBy}
          defaultPageSize={20}
          pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
          style={{ width: '100%' }}
        />
      </div>
    </>
  );
};

export default EventTableView;
